import * as React from 'react';
import { Col, Modal, Row, Input } from 'antd';
import Form, { FormItem } from '../../../components/Form';
import ProductSelect from 'src/components/Others/ProductSelect';
import { ICreateOrderItem } from 'data-layer/src/services/OrderItems/interfaces/ICreateOrderItem';

interface ICreateOrderItemEditorProps {
  onCreate: (data: ICreateOrderItem) => void;
  onCancel: () => void;
}

interface ICreateOrderItemEditorState {
  data: {
    variantId: string | undefined;
    ean: string;
    quantity: number;
  };
}

export default class CreateOrderItemEditor extends React.Component<ICreateOrderItemEditorProps, ICreateOrderItemEditorState> {

  private form;

  constructor(props: ICreateOrderItemEditorProps) {
    super(props);

    this.state = {
      data: {
        variantId: undefined,
        ean: '',
        quantity: 1,
      },
    };

    this.form = React.createRef;

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  public render() {
    return (
      <Modal
        title={'New order item'}
        visible={true}
        maskClosable={false}
        cancelText={'Cancel'}
        okText={'Create'}
        onOk={this.onSubmit}
        onCancel={() => this.props.onCancel()}
      >
        <Row>
          <Form
            ref={f => this.form = f}
            displayFooter={false}
            onSubmit={this.onSubmit}
            onCancel={() => this.props.onCancel()}
          >
            <FormItem label={'Product'} required={true}>
              <ProductSelect
                name={'variantId'}
                required={true}
                onChange={e => this.onChange(e, (e.target.value ? e.target.value.key : null))}
              />
            </FormItem>
            <FormItem label={'Quantity'} required={true}>
              <Input
                name={'quantity'}
                placeholder="Quantity"
                value={this.state.data.quantity}
                type={'number'}
                onChange={e => this.onChange(e, parseInt(e.target.value))}
              />
            </FormItem>
          </Form>
        </Row>
      </Modal>
    );
  }

  private onChange(e: any, val: any = null) {
    const value = val === null ? e.target.value : val;

    this.setState({
      data: {...this.state.data, [e.target.name]: value},
    });
  }

  private async onSubmit() {
    if (this.form) {
      if (this.form.validate()) {
        this.props.onCreate(this.state.data as ICreateOrderItem);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/scenes/OrderItems/OrderItemsEditors/CreateOrderItemEditor2.tsx